import React, { useEffect, useContext } from "react";
import { Redirect } from "react-router";
import { Authentication } from "@swegon/sds-core";

export const SignedOn = props => {
    const { signedOn, isAuthenticated } = useContext(Authentication.AuthContext);
    useEffect(() => {
        signedOn(props.location.hash);
    });
    return isAuthenticated() ? <Redirect to='/' /> : <div>Signing on...</div>;
};

export default SignedOn;
